export default __webpack_public_path__ + "static/media/CN.bfe03662.pdf";